/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import React, { useState, useEffect, Fragment } from 'react';
import { PrimaryButton, Spinner, SpinnerSize } from '@fluentui/react';
import { TextField, } from '@fluentui/react';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import axios from 'axios';
import { WarningFilled } from "@fluentui/react-icons";
import Lottie from 'lottie-react-web'
import animation from './animation.json'

const error = (e) => css`
    .ms-TextField-fieldGroup {
        border-color: ${e ? '#ff1f1f' : '#D5DBE4'};
    }
    .ms-TextField-errorMessage{
    color:#ff1f1f;
        padding-top: 0;
    }
    `;


const warning = () => css`
    display: flex;
    align-items: flex-start;
    background: rgb(254, 247, 225);
    border: 1px solid transparent;
    border-radius: 8px;
    padding: 12px 12px 12px 20px;
    max-width: 100%;
    width: 100%;
    font-family: "proxima-nova", "Arial CE", Arial, sans-serif;

    svg{
        font-size: 20px;
        color: rgb(214, 156, 0);
    }
    p{
        line-height: 18px;
        margin: 0;
        font-size: 13px;
        color: rgb(48, 54, 60);
    }
    `;
const lottie = () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 20px;
    `;

const container = () => css`
    .ms-TextField-reveal{
        height: 38px;
    }
    `;
function UpdatePassword(props) {
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(undefined);
    const [confirmPassword, setConfirmPassword] = useState();
    const [confirmPasswordError, setConfirmPasswordError] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState({ header: '', body: '' });
    const [showSuccess, setShowSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = (i, type, value) => {
        setLoading(true);
        var model = {
            Password: password,
            ConfirmPassword: confirmPassword
        }
        axios.post(AUTH_CONFIG.API_URL + "/api/auth/updatepassword", model)
            .then((response) => {
                setShowSuccess(true)
            })
            .catch((error) => {
                setLoading(false);
                setErrorMessage({
                    header: 'Invalid password.',
                    body: 'Please create a password with at least 8 characters, one lower case letter, one number and one special character.'
                });
            });
    }

    const handlePasswordChange = (event) => {
        setPassword(event.target.value);
        setPasswordError(undefined)
    };

    const handleConfirmPasswordChange = (event) => {
        setConfirmPassword(event.target.value);
        setConfirmPasswordError(undefined)
    };

    const password_validate = () => {
        var re = {
            capital: /(?=.*[A-Z])/,
            length: /(?=.{7,40}$)/,
            specialChar: /[ -\/:-@\[-\`{-~]/,
            digit: /(?=.*[0-9])/,
        };
        return (
            re.capital.test(password) &&
            re.length.test(password) &&
            re.specialChar.test(password) &&
            re.digit.test(password)
        );
    };

    return (
        <div className="displayflex" css={ container } style={{ maxWidth: 380 }}>
            {!showSuccess && <>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <div className="mb10" css={error(passwordError)}>
                            <TextField
                                styles={{ fieldGroup: { height: '40px' }, field: { height: '38px' } }}
                                errorMessage={passwordError}
                                id="password"
                                label="Password"
                                type="password"
                                value={password}
                                type="password"
                                canRevealPassword
                                onChange={handlePasswordChange}
                                onBlur={(e) => {
                                    if (!password_validate()) {

                                        setErrorMessage({
                                            header: 'Password not strong enough.',
                                            body: 'Please create a password with at least 8 characters, one lower case letter, one number and one special character.'
                                        })
                                    }
                                }}
                            />
                        </div>
                        <p className="secondary-small mb20" style={{ color: '#818b95' }}>
                            Your password must contain at least 8 characters, one lower case letter, one number and one special character.</p>
                        <div className="mb10" css={error(confirmPasswordError)}>
                            <TextField
                                styles={{
                                    fieldGroup: { height: '40px' },
                                    field: { height: '38px' },
                                    suffix: {
                                        height: '38px',
                                        display: 'flex',
                                        alignItems: 'center',
                                    },
                                }}
                                errorMessage={confirmPasswordError}
                                id="password"
                                label="Confirm new password"
                                type="password"
                                value={confirmPassword}
                                type="password"
                                canRevealPassword
                                onChange={handleConfirmPasswordChange}
                            />
                        </div>

                        {errorMessage.header && <div className="my10" css={warning}>
                            <div className="mr15"><WarningFilled /></div>
                            <div className="displayflex flexcolumn">
                                <h5 className="head-xs mb5">{errorMessage.header}</h5>
                                <p className="label-large">{errorMessage.body}</p>
                            </div>
                        </div>}
                        <div>
                            <PrimaryButton
                                text={!loading ? "Update" : <Spinner size={SpinnerSize.small} />}
                                disabled={!password_validate() || (password !== confirmPassword) || (!password)}
                                onClick={handleSubmit}
                                className="mt10 continue" />

                        </div>
                    </div>
                </form>
            </>}
            {showSuccess && <div className="flexcolumn aligncenter justifycenter">

                <div css={lottie}>
                    <Lottie
                        options={{
                            animationData: animation,
                            loop: false,
                        }}
                    />
                </div>
                <h2 className="head-30 mt20" >Password Changed!</h2>
                <p className="mb35 mt5" style={{ color: '#68707b' }}>Your password has been changed successfully.</p>
            </div>}

        </div>
    );
}

export default UpdatePassword;